import { apiClient } from "./apiClient"


// default api end point
export const getDefaultApi = 
    () => apiClient.get('/');

export const bookAppointmentService = (appointmentData) => {
        return apiClient.post('/add_appointment', appointmentData);
    };

export const getDoctors = 
    () => apiClient.get('/doctors');
